/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Label, LabelFromJSON, LabelFromJSONTyped, LabelToJSON } from './Label'

/**
 *
 * @export
 * @interface GetLabelsResponseData
 */
export interface GetLabelsResponseData {
  /**
   *
   * @type {Array<Label>}
   * @memberof GetLabelsResponseData
   */
  labels?: Array<Label>
}

export function GetLabelsResponseDataFromJSON(json: any): GetLabelsResponseData {
  return GetLabelsResponseDataFromJSONTyped(json, false)
}

export function GetLabelsResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLabelsResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    labels: !exists(json, 'labels') ? undefined : (json['labels'] as Array<any>).map(LabelFromJSON)
  }
}

export function GetLabelsResponseDataToJSON(value?: GetLabelsResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    labels: value.labels === undefined ? undefined : (value.labels as Array<any>).map(LabelToJSON)
  }
}
